var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('PaymentBody',{attrs:{"transactions":_vm.payment.payments,"total":_vm.payment.total,"page":_vm.payment.page,"loading":_vm.payment.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }